import config from '@/api/config'

let subUrl = '/basket'

export default {
  getBasket: {
    url: function () {
      return config.baseUrl + config.version2 + subUrl
    }
  },
  clearBasket: {
    url: function () {
      return config.baseUrl + config.version2 + subUrl
    }
  },
  updateBasket: {
    url: function () {
      return config.baseUrl + config.version2 + subUrl + '/update'
    }
  },
  addToBasket: {
    url: function () {
      return config.baseUrl + config.version2 + subUrl
    }
  },
  addUpsellToBasket: {
    url: function () {
      return config.baseUrl + config.version2 + subUrl + '/upsell'
    }
  }
}
